export const VENDOR_CONSTRAINTS = {
    name: { maxLength: 100, label: 'Vendor name' },
    url: { maxLength: 256, label: 'Website URL' },
    email: { maxLength: 256, label: 'Email address' },
    phone: { maxLength: 256, label: 'Phone number' },
    note: { maxLength: 256, label: 'Note' },
    creditLimit: { label: 'Credit limit' },
    leadTime: { label: 'Lead time' },
    minOrderAmount: { label: 'Min order amount' },
    paymentTerms: { label: 'Payment terms' },
    shipTerms: { label: 'Ship terms' },
    carrier: { label: 'Carrier' },
    status: { label: 'Relationship status' },
};
//# sourceMappingURL=constraints.js.map